import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ButtonComponent } from '../../atoms/button/button.component';
import { ModalComponent } from '../modal/modal.component';

/**
 * Modal that asks the user to confirm or cancel a potentially destructive operation.
 */
@Component({
  selector: 'es-confirm-dialog',
  imports: [ModalComponent, ButtonComponent],
  template: `
    <es-modal [open]="open" [title]="title" width="sm" (closed)="cancelled.emit()">
      <div class="p-6">
        <p class="text-sm text-[var(--text-secondary)]">{{ message }}</p>
      </div>
      <div class="flex justify-end gap-2 px-6 py-4 border-t border-[var(--border)]">
        <es-button variant="secondary" (clicked)="cancelled.emit()">
          {{ cancelLabel }}
        </es-button>
        <es-button [variant]="destructive ? 'danger' : 'primary'" (clicked)="confirmed.emit()">
          {{ confirmLabel }}
        </es-button>
      </div>
    </es-modal>
  `,
})
export class ConfirmDialogComponent {
  @Input() open = false;
  @Input() title = 'Bestätigung';
  @Input() message = 'Sind Sie sicher?';
  @Input() confirmLabel = 'Bestätigen';
  @Input() cancelLabel = 'Abbrechen';
  @Input() destructive = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
